import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api'; 
import './styles/Kidola.css';
import AuthContext from '../context/AuthContext';
import { useNavigate } from 'react-router-dom'; 

const TeacherLeaveFormPage = () => {
    const { teacherId } = useParams(); 
    const [bonusDate, setBonusDate] = useState('');
    const [bonus, setBonus] = useState(0);
    const [teacher, setTeacher] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();


    useEffect(() => {
        // Mendapatkan bulan dan tahun saat ini
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Menambahkan 0 di depan jika bulan < 10
        setBonusDate(`${year}-${month}`); // Format YYYY-MM
    }, []);

    useEffect(() => {
        
        api.get(`/teacher/profile/${teacherId}`)
          .then(response => {
                setTeacher(response.data?.data[0] || null);
          })
          .catch(error => console.error('Error fetching teacher list:', error));
    }, [teacherId]);

    const handleSubmit = () => {

        setErrorMessage('');

        // Validasi input
        if (!bonusDate || !bonus) {
            setErrorMessage('Please fill all field!');
            return;
        }

        const confirmation = window.confirm('Are you sure you want to proceed with this action?');
        if (!confirmation) {
            return;
        }
        
        const teacherData = {
            bonusDate: bonusDate,
            bonus: bonus,
            teacher_id: teacher.teacher_id
        };

        const requestBody = { data: { teacherData } };
        console.log('Request Body:', requestBody);
        api.post('/teacher/bonus/save', requestBody)
            .then(response => {
                const successMessage = response.data.message;
                console.log(successMessage);
                navigate('/success', { state: { message: successMessage } });
            })
            .catch(error => {
                console.error('Error adding/updating teacher:', error);
                navigate('/error', { state: { message: 'Please ask to administrator!' } });
            });
    };

    const formatCurrency = (amount) => {
        return parseFloat(amount).toLocaleString('id-ID', { minimumFractionDigits: 0 });
    };
    
    const handleBonusChange = (e) => {
        const value = e.target.value.replace(/\./g, '');
        if (value === '') {
            setBonus(0);
        }else {
            setBonus(parseFloat(value));
            
        }
    };

    return (
        <div className="transfer-inventory-page">
            <div className="page-title">Input Bonus</div>
            <h2></h2>
            <div className="form-container">
                <div className="section">
                <h3 className="section-header">Bonus Data</h3>
                    <div className="search-container">
                        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>} {/* Tampilkan pesan kesalahan */}
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Teacher Name</label>
                                    </td><td>
                                        <input 
                                            type="text" 
                                            name="teacherName" 
                                            value={teacher.teacher_name ?? ''} 
                                            readOnly
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Bonus Month</label>
                                    </td>
                                        <input 
                                            type="month"
                                            name="bonusDate"
                                            value={bonusDate} 
                                            onChange={e => setBonusDate(e.target.value)}
                                        />
                                </tr>
                                <tr>
                                    <td>
                                        <label>Bonus</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="text" 
                                            name="bonus" 
                                            value={formatCurrency(bonus)} 
                                            onChange={handleBonusChange} 
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="search-container">
                        <button onClick={handleSubmit}>Submit</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TeacherLeaveFormPage;
